import { render } from "./CookiesNumberInput.vue?vue&type=template&id=a400f3c6&scoped=true"
import script from "./CookiesNumberInput.vue?vue&type=script&lang=js"
export * from "./CookiesNumberInput.vue?vue&type=script&lang=js"

import "./CookiesNumberInput.vue?vue&type=style&index=0&id=a400f3c6&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a400f3c6"]])

export default __exports__